import React from "react";
import { useRef } from "react";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";
import { getTokenInfo } from "../utils/Guard";
import "./UserMenu.css";

const UserMenu = (props) => {
  const menuLeft = useRef(null);

  const items = [
    {
      template: () => {
        return (
          <>
            <Button
              label="Cerrar sesión"
              severity="danger"
              size="big"
              icon="pi pi-fw pi-power-off"
              className="logoutButton"
              onClick={props.logoutHandler}
            />
          </>
        );
      },
    },
  ];
  const userInfo = getTokenInfo();

  return (
    <>
      <Menu
        model={items}
        popup
        ref={menuLeft}
        id="popup_menu_left"
        className="logoutMenu"
      />
      <Button
        label={
          userInfo !== null &&
          userInfo.FullName !== undefined &&
          userInfo.FullName !== " "
            ? userInfo.FullName
            : "{User Name}"
        }
        className="userButton"
        icon="pi pi-caret-right"
        onClick={(event) => menuLeft.current.toggle(event)}
      />
    </>
  );
};
export default UserMenu;
